import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
const endpoint = environment.api_endpoint;
const headers = new HttpHeaders().set('Content-Type', 'application/json');
@Injectable({
  providedIn: 'root',
})
export class GraphServiceService {
  constructor(private http: HttpClient) {}

  // loadGraphData(data: any): Observable<any> {
  //   return this.http.post<any>(endpoint + '/graph', data)
  // }

  loadGraphData(data: any): Observable<any> {
    const accessToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      // 'X-Product-frontend': 'cc_frontend',
    });
    return this.http.post<any>(
      endpoint + '/analytics-service/v1/aggregate/graph',
      data,
      { headers },
    );
  }

  private refreshGraphSource = new Subject<void>();

  refreshGraph$ = this.refreshGraphSource.asObservable();

  triggerGraphRefresh() {
    this.refreshGraphSource.next();
  }
}
